import { jsx as _jsx } from "react/jsx-runtime";
import { mergeStyles } from '@fluentui/react';
import DOMPurify from 'dompurify';
import { useInjectedHtmlStyles } from '../HtmlBlock/useInjectedHtmlStyles';
import { markdownConverter } from './markdownConverter';
const { sanitize } = DOMPurify;
/**
 * Renders passed markdown as HTML (with sanitization).
 */
export const MarkdownBlock = ({ text = '', styles }) => {
    var _a, _b;
    const defaultStyles = useInjectedHtmlStyles();
    const textMinusXss = sanitize(text);
    // We're using the DOMPurify library to sanitize
    // the text. We have a unit test for the double backslash case.
    const mdWithCornerCases = (_b = (_a = textMinusXss // CodeQL [SM02383] This is a false positive. We have a unit test for this.
     === null || textMinusXss // CodeQL [SM02383] This is a false positive. We have a unit test for this.
     === void 0 ? void 0 : textMinusXss // CodeQL [SM02383] This is a false positive. We have a unit test for this.
    // Backslash escape for html open arrows
    .replace(/</g, '\\<') // CodeQL [SM02383] This is a false positive. We have a unit test for this.
    ) === null || _a === void 0 ? void 0 : _a.replace(/"/g, '&quot;')) === null || _b === void 0 ? void 0 : _b.replace(/'/g, '&#39;');
    const asHtml = markdownConverter.makeHtml(mdWithCornerCases);
    return (_jsx("div", { className: mergeStyles(defaultStyles, styles === null || styles === void 0 ? void 0 : styles.root), 
        // This component does XSS sanitization.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: asHtml } }));
    // IMPORTANT: HtmlBlock is our sanitizer against XSS attacks!
    // return <HtmlBlock text={result} styles={merge({}, defaultStyles, styles)} />;
};
